import styled from 'styled-components';

export const Container = styled.div`
  .backgroundHeader {
    height: 136px;
    background: #fe501c;
    @media (max-width: 769px) {
      display: none;
    }
  }

  .banner {
    max-width: 100vw !important;
    width: 100%;
    height: 400px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 100px;

    background: #fe501c;

    @media (max-width: 662px) {
      padding: 0 20px;
    }

    .text {
      width: 70%;
      font-size: 26px;
      color: #fff;
      a {
        color: #000;
      }
      @media (max-width: 837px) {
        font-size: 16px;
      }
    }
  }
`;

export const Chat = styled.div`
  text-align: -webkit-center;
  display: flex;
  justify-content: center;

  @media (max-width: 730px) {
    padding: 20px;
  }

  @media (max-width: 360px) {
    width: 100vw;
  }

  h2 {
    font-size: 25px;
    color: #fe501c;
  }
  span {
    font-size: 18px;
    color: #fff;
  }

  div {
    margin-top: 10px;

    width: fit-content;
    border-radius: 22px;
    padding: 10px;

    @media (max-width: 360px) {
      width: 100%;
    }
  }

  .chat-button {
    height: 90px;
    width: 280px;
    background: #000;

    @media (max-width: 360px) {
      width: 100%;
    }

    .loading {
      color: #fe501c;
    }
  }

  button {
    display: flex;
    flex-direction: column;
    height: 90px;
    width: 100%;
    padding: 10px 20px;
    border-radius: 20px;
  }
`;

export const Content = styled.div`
  margin-top: 50px;
  margin-bottom: 20px;

  justify-content: space-evenly;
  display: flex;

  @media (max-width: 769px) {
    flex-direction: column;
    align-items: center;
    padding: 0 50px;
  }

  @media (max-width: 440px) {
    padding: 0 20px;
  }

  .box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    width: 20%;
    height: 200px;

    @media (max-width: 1150px) {
      height: unset;
    }

    @media (max-width: 769px) {
      width: unset;
      margin-bottom: 60px;
    }

    @media (max-width: 730px) {
    }

    h2 {
      font-size: 25px;
      @media (max-width: 1150px) {
        margin-bottom: 5px;
      }
    }
    span {
      font-size: 18px;
      @media (max-width: 1150px) {
        margin-bottom: 5px;
      }
    }
    a {
      color: #fe501c;
      font-size: 18px;
      @media (max-width: 1150px) {
        margin: 5px 0;
      }
    }
  }
`;

export const Social = styled.div`
  display: flex;
  flex-direction: column;
  padding: 100px;

  @media (max-width: 769px) {
    padding: 0 50px;
  }
  @media (max-width: 440px) {
    padding: 0 20px;
  }

  h1 {
    font-size: 25px;
    margin: 10px 0;
  }
  span {
    font-size: 18px;
    margin-bottom: 60px;
  }
  div {
    display: flex;
    justify-content: space-evenly;

    @media (max-width: 390px) {
      flex-direction: column;
    }
  }
  a {
    color: #fe501c;
    font-size: 18px;
    margin-bottom: 60px;
    @media (max-width: 769px) {
      &:last-child {
        margin-bottom: 120px;
      }
    }
  }
`;
